/** Joins class names, skipping empty ones: cx('btn', large && 'lg') */
export function cx(...names: Array<string | false | null | undefined>): string {
  return names.filter(Boolean).join(' ');
}
